import React from "react";
import { StaticHero } from "../../components/StaticHero";
import { Container } from "react-bootstrap";
import { OrderForm } from "../../components/OrderForm";
import Footer from "../../components/Footer/Footer";
import { useParams } from "react-router-dom";
import { FDM3dPrintingForm } from "../../components/FDM3dPrintingForm";
import SLA3DPrintingForm from "../../components/SLA3DPrintingForm/SLA3DPrintingForm";
import LaserCuttingForm from "../../components/LaserCuttingForm/LaserCuttingForm";
import { PCBForm } from "../../components/PCBForm";
import { ProductDevelopmentForm } from "../../components/ProductDevelopmentForm";

const OrderNowPage = () => {
  const { type } = useParams();
  const heroConf = {
    title: "Order Now",
    subtitle:
      "if you need our help,have questions about how to use the platform or are experiencing technical difficulties,please do not hesitate to contact us",
  };
  return (
    <div>
      <StaticHero {...heroConf} contact={true} />
      <Container className="py-5">
        {!type ? (
          <OrderForm />
        ) : type === "3D-Printing-fdm" ? (
          <FDM3dPrintingForm />
        ) : type === "3D-Printing-sla" ? (
          <SLA3DPrintingForm />
        ) : type === "Laser-Cutting" ? (
          <LaserCuttingForm />
        ) : type === "PCB-Manufacturing" ? (
          <PCBForm />
        ) : type === "Product-Development" ? (
          <ProductDevelopmentForm />
        ) : (
          <></>
        )}
      </Container>
      <Footer />
    </div>
  );
};

export default OrderNowPage;
